import { Component, Injector, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { Utils } from '../../../../shared/Utils/Utils';
import { BaseSWQuestion } from '../../../extended-class/base-ws-question';
import { LookUpResourceModel } from '../../../models/lookup-resource.model';

@Component({
  selector: '[postalCode]',
  templateUrl: './postal-code.component.html'
})
export class PostalCodeComponent extends BaseSWQuestion implements OnInit {
  question: LookUpResourceModel;
  postalCode: string;
  isValidPostalCode = true;

  constructor(serviceInjector: Injector) {
    super(serviceInjector);
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((param: any) => {
      this.question = JSON.parse(param['question']);
    });

    this.swProcessStateService.swContractType$.pipe(take(1)).subscribe((contractType) => {
      this.contractType = JSON.parse(JSON.stringify(contractType));
      this.postalCode = this.contractType.postalCode;
      this.getPredictZipCode(this.postalCode);
    });
  }

  GetCityByPostCode() {
    this.contractType.province = '';
    if (this.postalCode.length >= 3) {
      this.getPredictZipCode(this.postalCode);
    }
  }

  getPredictZipCode(postalCode: string) {
    this.customerJourneyService.getPostalCodeDetails(postalCode).subscribe((result) => {
      if (result) {
        this.contractType.postalCode = result.postalCode;
        this.contractType.province = result.provinceName;
      } else {
        this.contractType.postalCode = '';
      }
      this.isValid();
    });
  }

  saveSectionAnswer() {
    if (this.isValidPostalCode) {
      this.addGTMAnswer(this.question.QuestionNumber, this.contractType.postalCode);
      this.swProcessStateService.updateSwProcessModel(this.contractType);
      this.sectionWiseService.closeSwqModal(this.question);
    } else {
      this.gtmDatalayerUiService.addVirtualPageValidationError('Q6', 2, 'Por favor introduce un código postal correcto.');
    }
  }

  numberOnly(evt: any) {
    return Utils.isNumber(evt);
  }

  isValid() {
    this.isValidPostalCode = this.contractType.postalCode?.length > 0 && this.contractType.postalCode.length >= 4 && this.contractType.postalCode.length <= 5;
  }
}
